module.exports = __webpack_public_path__ + "static/media/redux.8251fe76.png";